import ImageUploader from '../../components/ImageUploader/ImageUploader';
import styled from 'styled-components';
import { StyledImageHolder } from '../../components/ImageUploader/ImageUploader.styles';

export const StyledImageUploader = styled(ImageUploader)`
  width: 320px;

  ${StyledImageHolder} {
    height: 200px;
  }
`;
